module.exports = __webpack_public_path__ + "media/images/bg-masthead-bde300d68b5e077aa9fb609f96863a13.jpg";